import { reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useLoader } from '../useLoader'
import { useError } from '../useError'
import { useReceipts } from './useReceipts'
import { useNotifications } from '@/services/notification/useNotifications'
import { useDialog } from '@/services/useDialog'
import { useLogs } from '@/services/useLogs'
import { useTopData } from '@/services/useHome'
import axios from '@/axios'

const rejectHeaders = reactive([
  { title: '経費項目', attr: 'expenseTypeId', comment: '' },
  { title: '支出額', attr: 'expenseAmount', comment: '' },
  { title: '支出年月日', attr: 'expenseDate', comment: '' },
  { title: '支出内容', attr: 'expenseContent1', comment: '' },
  { title: '補記', attr: 'expenseContent2', comment: '' },
  { title: '領収書添付', attr: 'files', comment: '' },
  { title: 'メッセージ', attr: 'officeMessage', comment: '' },
])

const isRejectBtnEnabled = ref(false)
const rejectedAttrs = reactive([])

export const useReceiptReject = () => {
  const { currentReceipt, getReceiptsAfterResponse } = useReceipts()
  const { getNotificationsAfterResponse } = useNotifications()
  const { getTimelineAfterResponse } = useLogs()
  const { getTopDataAfterResponse } = useTopData()
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const route = useRoute()
  const resetRejectedItems = () => {
    while (rejectedAttrs.length > 0) {
      rejectedAttrs.pop()
    }
    rejectHeaders.forEach(x => (x.comment = ''))
  }

  let data = reactive({})

  const toUnderscoreCase = str => {
    return str
      .split(/(?=[A-Z])/)
      .join('_')
      .toLowerCase()
  }

  const toSnake = () => {
    for (let i = 0; i < rejectedAttrs.length; i++) {
      Object.keys(rejectedAttrs[i]).forEach(function(key) {
        if (key === 'target') {
          rejectedAttrs[i][key] = toUnderscoreCase(rejectedAttrs[i][key])
        }
      })
    }
  }
  const submitReject = async (id, userRank) => {
    try {
      toggleShowLoader(true)

      if (userRank === 2) {
        const payload = {
          is_temporary: false,
          expense_type_id: currentReceipt.expenseTypeId[0].id,
          expense_date: currentReceipt.expenseDate,
          expense_amount: currentReceipt.expenseAmount,
          expense_content1: currentReceipt.expenseContent1,
          expense_content2: currentReceipt.expenseContent2,
          is_distributed: currentReceipt.isDistributed,
          partial_amount: currentReceipt.isPartial
            ? currentReceipt.partialAmount
            : null,
          partial_comment: currentReceipt.isPartial
            ? currentReceipt.partialComment
            : '',
          numerator: currentReceipt.numerator,
          denominator: currentReceipt.denominator,
          images: currentReceipt.images,
        }
        await axios.put(`/receipts/${id}`, payload)
      }

      toSnake()
      data = {
        sent_back_items: rejectedAttrs,
      }
      let res = null
      res = await axios.post(`/receipts/reject/${id}`, data)
      if (route.name === 'Receipts') {
        await getReceiptsAfterResponse(res)
      } else if (route.name !== 'Receipts') {
        const { closeDialog } = useDialog()
        closeDialog()
        if (route.name === 'Top') {
          await getTopDataAfterResponse(res)
        } else if (route.name === 'Logs') {
          await getTimelineAfterResponse(res)
        } else if (route.name === 'Notifications') {
          await getNotificationsAfterResponse(res)
        }
      }
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  return {
    rejectHeaders,
    rejectedAttrs,
    isRejectBtnEnabled,
    resetRejectedItems,
    submitReject,
    toSnake,
  }
}
